import 'regenerator-runtime/runtime'
import '@lottiefiles/lottie-player'

import "/_atoms/countup/countup.ts";
import "/_atoms/svg-animation/svg-animation.ts";
import "/_atoms/vivus/vivus.ts";

import "/_components/highchart/highchart.js";
import "/_components/home/home.ts";
import "/_components/navigation/navigation.ts";
import "/_components/scroll-reveal/scroll-reveal.ts";
import "/_components/slider/slider.ts";
import "/_components/info-box/info-box.ts";
import "/_components/interview/interview.ts";
import "/_components/highlights/highlights.ts";
import "/_components/graphic/graphic.ts";
import "/_components/sfx/sfx.ts";
import "/_components/tooltip/tooltip.ts";
import "/_components/circles/circles.ts";
import "/_components/accordion/accordion.ts";
import "/_components/video/video.ts";
import "/_components/cookie/cookie.ts";
// import "/_components/lottie/lottie.ts";




// import "/_components/slider-box/slider-box.ts";
// import "/_atoms/growing/growing.ts";
// import "/_atoms/hero-animations/hero-animations.ts";
// import "/_atoms/hero-images/hero-images.ts";
// import "/_atoms/horizontal-scrolling/horizontal-scrolling.ts";
// import "/_atoms/intro-parallax/intro-parallax.ts";
// import "/_atoms/map/map.ts";
// import "/_atoms/pinned-sidebar/pinned-sidebar.ts";
// import "/_atoms/toTop/toTop.ts";


// import "/_components/bg-color-change/bg-color-change.ts";
// import "/_components/dual-image/dual-image.ts";
// import "/_components/img-description/img-description.ts";
// import "/_components/fixed/fixed.ts";
// import "/_components/stretched-text/stretched-text.ts";
// import "/_components/triple-image/triple-image.ts";
